export const LegalLinks = () => (<>
    <a href="https://www.iubenda.com/terms-and-conditions/61481873" target="_blank" rel="noreferrer">
        Terms and Conditions
    </a>
    <span className="px-2">|</span>
    <a href="https://www.iubenda.com/privacy-policy/61481873" target="_blank" rel="noreferrer">
        Privacy Policy
    </a>
</>)
